import { StrictMode } from "react";
import { App as AntApp, ConfigProvider } from "antd";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { router } from "./app/router";
import { mbipTheme } from "./app/theme";
import i18n from "./i18n";
import "./styles/tokens.css";
import "./styles/app.css";
import { AuthProvider } from "./context/AuthContext";

const root = document.getElementById("root");
if (root === null) {
  throw new Error("MBIP React root element is missing.");
}

createRoot(root).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <ConfigProvider theme={mbipTheme} componentSize="middle">
        <AntApp>
          <AuthProvider><RouterProvider router={router} /></AuthProvider>
        </AntApp>
      </ConfigProvider>
    </I18nextProvider>
  </StrictMode>,
);
